export type Dictionary<T> = { [key: string]: T | undefined };

export function keyBy<T>(collection: ReadonlyArray<T> | undefined, iteratee: (value: T) => string): Dictionary<T> {
  if (collection === undefined) {
    return {};
  }
  return collection.reduce(
    (result: Dictionary<T>, value) => {
      result[iteratee(value)] = value;
      return result;
    },
    {}
  );
}
